import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';
import FeatureSection from './components/FeatureSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <CategoryNav />
        <TrendingSection />
        <LatestSection />
        <FeatureSection />
      </main>
      <Footer />

      <script type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "樱花动漫-在线免费观看动漫-专注手机动漫的门户网站-樱花动漫之家",
            "description": "樱花动漫之家让您在线免费观看动漫，这个门户网站专注于手机用户，提供便捷的访问方式，让您随时随地通过移动设备欣赏各种动漫作品。",
            "url": "https://www.yinghuadongman.com/",
            "isPartOf": { "@id": "https://www.yinghuadongman.com/" }
          })
        }}
      />
    </>
  );
}